import { Outlet } from "@tanstack/react-router";
import { useDocTitle } from "@/hooks/useDocTitle";

export default function RootComponent() {
  useDocTitle();

  return (
    <>
      <Outlet />
    </>
  );
}
